import { render, staticRenderFns } from "./CouponTableList.vue?vue&type=template&id=3fd0d3f0&scoped=true"
import script from "./CouponTableList.vue?vue&type=script&lang=js"
export * from "./CouponTableList.vue?vue&type=script&lang=js"
import style0 from "./CouponTableList.vue?vue&type=style&index=0&id=3fd0d3f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd0d3f0",
  null
  
)

export default component.exports